module.exports = __webpack_public_path__ + "img/qr.e9a139ed.png";